import { _api } from '@/utils/apiAxios';
import groupBy from 'lodash/groupBy';
import { createBet } from '../components/bet-slip/bet-slip-utils';

const state = {
  freeWagers: {},
  freeWagersViewing: false,
  selectedFreeWager: {},
  showExitFreeWageringModal: false,
  showPicksAddedModal: false,
};

const getters = {};

const mutations = {
  setFreeWagers(state, freeWagers) {
    state.freeWagers = freeWagers;
  },
  setSelectedFreeWager(state, selectedFreeWager) {
    state.selectedFreeWager = selectedFreeWager;
  },
  setFreeWagersViewing(state, freeWagersViewing) {
    state.freeWagersViewing = freeWagersViewing;
    if (freeWagersViewing === false) {
      state.selectedFreeWager = {};
    }
  },
  setShowExitFreeWageringModal(state, showExitFreeWageringModal) {
    state.showExitFreeWageringModal = showExitFreeWageringModal;
  },
  setShowPicksAddedModal(state, showPicksAddedModal) {
    state.showPicksAddedModal = showPicksAddedModal;
  },
};

const actions = {
  tryGetAvailableFreeWagers({ commit }) {
    _api.get('/free-wager/available').then(r => {
      if (r.data.IsSuccess) {
        let freeWagers = groupBy(r.data.Data, 'free_wager.wager_type');
        commit('setFreeWagers', freeWagers);

        if (freeWagers.length === 0) {
          commit('setFreeWagersViewing', false);
        }
      }
    });
  },
  tryGetFreeWagerLines({ state, rootState, commit }) {
    const language_id = rootState.settings.selectedLocale.id;
    const selectedFreeWagerId = state.selectedFreeWager.id;
    const selectedOddType = rootState.settings.selectedOddType;
    commit('betSlip/setSelectedBetType', state.selectedFreeWager.wager_type, {
      root: true,
    });
    commit('setFreeWagersViewing', true);
    commit('betLines/initializing', null, { root: true });
    _api
      .get(
        `/free-wager/lines?freeWagerId=${selectedFreeWagerId}&language_id=${language_id}&line_style=${selectedOddType}`,
      )
      .then(res => {
        if (res.data.IsSuccess) {
          const list = res.data.Data.headers ? res.data.Data.headers : [];
          commit('betLines/requestSuccess', list, { root: true });
          commit('betLines/setSportGroup', list, { root: true });
          commit('betLines/requestEnded', null, { root: true });
        }
      });
  },
  beforeAddBetToBetSlipCheckFreeWager({ state, commit }) {
    if (!state.freeWagersViewing) {
      return;
    }

    const wager_type = state.selectedFreeWager.wager_type;
    commit('betSlip/setSelectedBetType', wager_type, { root: true });
  },
  afterAddBetToBetSlipCheckFreeWagerAndBuildBets({ state, commit, dispatch }, { selection }) {
    if (!state.freeWagersViewing || !state.selectedFreeWager.id) {
      return;
    }

    const selectedFreeWager = state.selectedFreeWager;
    const betAmountSetting = selectedFreeWager.free_wager_settings.filter(s => s.name === 'bet_amount')[0];
    const fixAmountSetting = selectedFreeWager.free_wager_settings.filter(s => s.name === 'fix_amount')[0];
    const betAmount = betAmountSetting ? betAmountSetting.value : '';
    const fixAmount = fixAmountSetting ? fixAmountSetting.value : '';
    const wager_type = selectedFreeWager.wager_type;

    if (betAmount) {
      if (wager_type === 'straight') {
        dispatch('betSlip/createOrUpdateBet', createBet('straight', selection.id, betAmount, 0, 0, 0, null), {
          root: true,
        });
      } else {
        dispatch('betSlip/createOrUpdateBet', createBet(wager_type, 0, betAmount, 0, 0, 0, null), { root: true });
      }
    }

    if (fixAmount) {
      if (wager_type === 'straight') {
        dispatch('betSlip/createOrUpdateBet', createBet('straight', selection.id, 0, fixAmount, 0, 0, null), {
          root: true,
        });
      } else {
        dispatch('betSlip/createOrUpdateBet', createBet(wager_type, 0, 0, fixAmount, 0, 0, null), { root: true });
      }
    }

    commit('setShowPicksAddedModal', true);
  },
};

export const freeWagerStore = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
